module.exports = __webpack_public_path__ + "img/img-left.6d72fa4.png";